import { useState } from "react";
import { ChevronDown, HelpCircle } from "lucide-react";
import { useSiteSettings } from "../hooks/useSiteSettings";

export default function FaqSection() {
    const { settings } = useSiteSettings();
    const faq = settings?.faq || [];
    const [openIdx, setOpenIdx] = useState(0);

    if (!faq.length) return null;

    return (
        <section data-testid="faq-section" className="py-12 sm:py-16 bg-gradient-to-b from-sand to-white">
            <div className="max-w-4xl mx-auto px-4 sm:px-6">
                <div className="text-center mb-8">
                    <div className="inline-flex items-center gap-2 bg-mexyellow/30 text-cocoa px-4 py-1.5 rounded-full text-sm font-semibold mb-3">
                        <HelpCircle className="w-4 h-4" /> Preguntas frecuentes
                    </div>
                    <h2 className="font-display text-3xl sm:text-4xl font-bold text-cocoa">
                        ¿Tienes dudas?
                    </h2>
                    <p className="text-muted-foreground mt-2">
                        Aquí están las respuestas a lo que más nos preguntan.
                    </p>
                </div>

                <div className="space-y-3">
                    {faq.map((item, i) => {
                        const open = openIdx === i;
                        return (
                            <div
                                key={i}
                                data-testid={`faq-item-${i}`}
                                className={`bg-white rounded-2xl border transition-all ${
                                    open ? "border-mexred shadow-md" : "border-border hover:border-mexred/50"
                                }`}
                            >
                                <button
                                    type="button"
                                    onClick={() => setOpenIdx(open ? -1 : i)}
                                    className="w-full flex items-center justify-between gap-3 text-left px-5 py-4"
                                >
                                    <span className="font-display font-semibold text-cocoa text-base sm:text-lg">
                                        {item.question}
                                    </span>
                                    <ChevronDown
                                        className={`w-5 h-5 text-mexred shrink-0 transition-transform ${
                                            open ? "rotate-180" : ""
                                        }`}
                                    />
                                </button>
                                <div
                                    className={`grid transition-all duration-300 ease-out ${
                                        open ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
                                    }`}
                                >
                                    <div className="overflow-hidden">
                                        <p className="px-5 pb-4 text-sm sm:text-base text-muted-foreground leading-relaxed">
                                            {item.answer}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
